import React from "react"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"
import { ButtonNova } from "@nutrafol/nutrafol-ui-kit/dist/ButtonNova"

import { CardBox, ProductLink, BottomWrap } from "./products.styled"

const ProductCard = ({ product, index }) => {
  const { name, description, shortDescription, image, button } = product

  const onClick = () => {
    segmentEvent("Marketing CTA Clicked", {
      destination: button.url,
      type: "button",
      text: button.label,
      module_name: "product",
    })
  }

  return (
    <CardBox width={[0.5, null, 0.25]}>
      <ProductLink
        to={button.url}
        onClick={onClick}
        className="px-[16px] sm:px-[24px] py-[24px] sm:pb-[32px] block md:flex md:flex-col md:h-full md:justify-between"
      >
        <div>
          <TextElementNova
            text={name}
            element="h3"
            className="Body-30-Dia-Strong text-left hidden md:block mb-[4px]"
          />
          <TextElementNova
            text={description}
            element="p"
            className="Body-10-Dia-Normal text-center md:text-left hidden md:block mb-[16px] max-w-[200px]"
          />
          <TextElementNova
            text={shortDescription}
            element="p"
            className="Body-20-Dia-Normal text-center md:hidden mb-[8px] sm:mb-[16px]"
          />
        </div>
        <BottomWrap>
          <img
            src={image}
            alt={`Bottle of Nutrafol ${name}`}
            className="px-[16px] sm:px-[12px] md:px-[16px] mb-[8px] sm:mb-[16px] md:mb-[32px]"
          />
          <div className="sm:mx-[-15px] md:mx-0">
            <ButtonNova
              label={button.label}
              level="Textlink"
              className="mx-auto md:!hidden"
            />
            <ButtonNova
              label="Shop Now"
              level="Primary"
              icon={"Right"}
              className="mx-auto !hidden md:!flex"
            />
          </div>
        </BottomWrap>
      </ProductLink>
    </CardBox>
  )
}

export default ProductCard
